import { SidebarFeatureEnum } from 'config/types/sidebar'
import React from 'react'
import TournamentPage from 'views/Tournament'

const SidebarFeatures: React.FC<{ feature: SidebarFeatureEnum }> = ({ feature }) => {
  const renderFeature = () => {
    switch (feature) {
      case SidebarFeatureEnum.Tournament:
        return <TournamentPage />

      // add more features here
      default:
        return null
    }
  }

  return renderFeature()
}

export default SidebarFeatures
